<template>
  <ul class="team-members-grid grid grid-gap-20">
    <slot />
  </ul>
</template>

<script>
export default {
  props: {
    teamMembers: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
/* One full-width column on phones, then as many 320px+ columns as fit */
.team-members-grid {
  grid-template-columns: minmax(0, 1fr);
}

@screen tablet {
  .team-members-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
}
</style>
